import Icon from '../icon/Icon';

const AuthButton = ({ href, className, icon }) => (
	<a href={href} className={`auth-button ${className}`}>
		<Icon name={icon} className={`icon-${icon}`} />
	</a>
);

export default AuthButton;
